import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import { RouteName } from "@/router";
import AppHeader from "@/components/AppHeader.vue";
import { useAuthStore } from "@/store/auth.store";
import { useTargetStore } from "@/store/target.store";
import { useCombinedTargetStore } from "@/store/combinedTarget.store";
import { useCanvasStore } from "@/store/canvas.store";
import { useDeviceStore } from "@/store/device.store";
import Home from "./views/Home.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const authStore = useAuthStore();
const targetStore = useTargetStore();
const combinedTargetStore = useCombinedTargetStore();
const canvasStore = useCanvasStore();
const deviceStore = useDeviceStore();

const isHeaderShow = computed(() => {
  if (route.name === Home.name) return false;
  return authStore.isLoggedIn;
});

const updateData = async (routeName: string) => {
  switch (routeName) {
    case RouteName.Dashboard:
      await canvasStore.fetch();
      return;
    case RouteName.Targets:
      await Promise.all([targetStore.fetch(), combinedTargetStore.fetch()]);
      return;
    case RouteName.Devices:
      await deviceStore.fetch();
      return;
  }
};

onMounted(() => {
  setInterval(() => {
    if (typeof route.name === "string") updateData(route.name);
  }, 15000);
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(isHeaderShow))
      ? (_openBlock(), _createBlock(AppHeader, {
          key: 0,
          class: "mb-2 shadow-2"
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component }) => [
        (_openBlock(), _createBlock(_KeepAlive, null, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
        ], 1024))
      ]),
      _: 1
    })
  ], 64))
}
}

})